export default __webpack_public_path__ + "static/media/favicon.3b644b58.ico";